import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Overview14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.75 5.8C5.75 5.2201 6.2201 4.75 6.8 4.75H9.2C9.7799 4.75 10.25 5.2201 10.25 5.8V8.2C10.25 8.7799 9.7799 9.25 9.2 9.25H6.8C6.2201 9.25 5.75 8.7799 5.75 8.2V5.8ZM7.25 7.75H8.75V6.25H7.25V7.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 1.25C3.82436 1.25 1.25 3.82436 1.25 7C1.25 8.31746 1.69308 9.53143 2.43836 10.501L0.469727 12.4697L1.53039 13.5303L3.49902 11.5617C4.46862 12.3069 5.68257 12.75 7 12.75C10.1756 12.75 12.75 10.1756 12.75 7C12.75 3.82436 10.1756 1.25 7 1.25ZM3.39378 4.75C4.14474 3.54892 5.47907 2.75 7 2.75C9.34721 2.75 11.25 4.65279 11.25 7C11.25 9.34721 9.34721 11.25 7 11.25C5.47907 11.25 4.14474 10.4511 3.39378 9.25H3.70005C4.27995 9.25 4.75005 8.7799 4.75005 8.2V5.8C4.75005 5.2201 4.27995 4.75 3.70005 4.75H3.39378ZM2.81597 6.25C2.72927 6.73691 2.72927 7.26309 2.81597 7.75H3.25005V6.25H2.81597Z'
      fill='currentColor'
    />
  </Svg>
);

Overview14.displayName = 'Overview14';
export default Overview14;
